/** @format */

import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

import rootSaga from './rootSaga';
import { createRootReducer } from './rootReducer';
import rootMiddleware from './rootMiddleware';
import history from './history';
import createSagaMiddleware from 'redux-saga';
import { responsiveStoreEnhancer } from './responsiveState';

const persistConfig = {
  key: 'root',
  storage: storage,
  blacklist: ['router'],
  transforms: [
    createTransform(
      inboundState => {
        const parserFormValues = inboundState && inboundState.formValues && inboundState.formValues.formValues;

        if (!parserFormValues) {
          return inboundState;
        }

        const persistableParserFormValues = { ...parserFormValues };
        delete persistableParserFormValues.rawElements;
        delete persistableParserFormValues.rawElementsIndex;

        return {
          ...inboundState,
          formValues: {
            ...inboundState.formValues,
            formValues: persistableParserFormValues,
          },
        };
      },
      outboundState => outboundState,
      { whitelist: ['questionnaire'] },
    ),
  ],
  stateReconciler: autoMergeLevel2, // see "Merge Process" section for details.
};
const composeEnhancers =
  process.env.NODE_ENV !== 'production' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

/* middleware that needs to live outside the rootMiddleware */
const sagaMiddleware = createSagaMiddleware();

function configureStore(preloadedState, history) {
  const middleware = rootMiddleware([sagaMiddleware]);

  const persistRootReducer = persistReducer(persistConfig, createRootReducer(history));

  const store = createStore(
    persistRootReducer,
    preloadedState,
    composeEnhancers(responsiveStoreEnhancer, applyMiddleware.apply(null, middleware)),
  );

  if (module.hot)
    module.hot.accept('./rootReducer', () => {
      const nextRootReducer = require('./rootReducer').createRootReducer;
      store.replaceReducer(persistReducer(persistConfig, nextRootReducer(history)));
    });

  sagaMiddleware.run(rootSaga);
  history.listen(({ location }) => {
    store.dispatch({ type: '@@router/LOCATION_CHANGE', payload: { location } });
  });
  return store;
}

const store = configureStore({}, history);
const persistor = persistStore(store);
export { store, history, persistor };
export default store;
